// usePhase
// Features:
// - Manages the high-level application lifecycle (Phases)
// - Defines valid phases (Loading -> Warmup -> Intro -> Menu -> Entering -> InCabin)
// - Provides methods to transition between phases safely

import { create } from 'zustand'

export const PHASES = Object.freeze({
    loading: 'loading',
    warmup: 'warmup',
    introTravel: 'introTravel',
    menuIdle: 'menuIdle',
    enteringCabin: 'enteringCabin',
    inCabin: 'inCabin',
})

export const usePhase = create((set, get) => ({
    phase: PHASES.loading,

    // Transition to a new phase (with validation)
    setPhase: (nextPhase) => {
        const allowed = Object.values(PHASES)
        if (!allowed.includes(nextPhase)) return
        if (get().phase === nextPhase) return

        set({ phase: nextPhase })
    },

    // Helper to check current phase
    is: (p) => get().phase === p,

    // Reset to initial state
    resetPhase: () => {
        set({ phase: PHASES.loading })
    },
}))
